// extracted by mini-css-extract-plugin
module.exports = {"testnet_badge":"TestnetBadge_testnet_badge__16Vpf"};